import { t } from '../helpers/i18n';

const LEAD_TYPE: { [key: string]: any } = {
  PERSONAL: {
    label: t('Personal'),
    value: 'ca_nhan',
  },
  COMPANY: {
    label: t('Company'),
    value: 'cong_ty',
  },
  ENTERPRISE: {
    label: t('Enterprise'),
    value: 'doanh_nghiep',
  },
  HOUSEHOLD_BUSINESS: {
    label: t('HouseholdBusiness'),
    value: 'ho_kinh_doanh',
  },
};

const KEY_LOCATION: { [key: string]: string } = {
  PROVINCES: '1',
  DISTRICTS: '2',
  WARDS: '3',
};

const LEAD_TYPE_MAPPING: { [key: string]: any } = {
  INDIVIDUAL: {
    value: 1,
  },
  ENTERPRISE: {
    value: 2,
  },
};

// Status lấy từ api, chấp nhận fix cứng theo tên
const LEAD_STATUS_CONVERTED_VNNG = 'Đồng ý, đã ký HĐ';
const LEAD_STATUS_CONVERTED_DGL = 'Đã chốt hợp đồng';

export default {
  LEAD_TYPE,
  KEY_LOCATION,
  LEAD_TYPE_MAPPING,
  LEAD_STATUS_CONVERTED_VNNG,
  LEAD_STATUS_CONVERTED_DGL,
  MAX_CONTACT_INFO: 5,
};
